const { useLocation } = require('react-router-dom');

const useQuery = ():{ [key:string]: string } => {
  const params = new URLSearchParams(useLocation().search);
  return Array.from(params).reduce((result, [key, value]) => ({
    ...result,
    [key]: value,
  }), {});
};

export default useQuery;
const { useLocation } = require('react-router-dom');

const useQuery = ():{ [key:string]: string } => {
  const params = new URLSearchParams(useLocation().search);
  return Array.from(params).reduce((result, [key, value]) => ({
    ...result,
    [key]: value,
  }), {});
};

export default useQuery;
